/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col lg:w-6/12 md:w-6/12 sm:w-5/5">
        <vx-card class="mb-base">
          <h3 class="font-bold mb-6 main-bottom-border pb-4">Code Snippet #1</h3>

          <div class="mb-6 w-full">
            <h4>Vulnerability</h4>
            <v-select
              placeholder="Select the vulnerability from the dropdown"
              class="w-full mt-2"
              :options="[
                'SQL Injection',
                'Cross-site request forgery',
                'Server-side request forgery',
                'Indirect object reference',
                'Cross-site scripting',
              ]"
              v-model="snippets[0].vulnerabilityValue"
            />

            <small v-if="snippets[0].vulnerabilityMarked === true" class="ml-1 text-success font-semibold">This answer is correct</small>
            <small v-if="snippets[0].vulnerabilityMarked === false" class="ml-1 text-danger font-semibold">This answer is incorrect</small>
          </div>

          <div class="mb-6 w-full">
            <h4>Fix</h4>
            <v-select
              placeholder="Select the fix from the dropdown"
              class="w-full mt-2"
              :options="[
                'Perform input sanitization of the userid field.',
                'Perform output encoding of queryResponse',
                'Ensure usex:ia belongs to logged-in user',
                'Inspect URLS and disallow arbitrary requests.',
                'Implement anti-forgery tokens.',
              ]"
              v-model="snippets[0].fixValue"
            />

            <small v-if="snippets[0].fixMarked === true" class="ml-1 text-success font-semibold">This answer is correct</small>
            <small v-if="snippets[0].fixMarked === false" class="ml-1 text-danger font-semibold">This answer is incorrect</small>
          </div>

          <div class="text-success bg-light main-border p-4 rounded" style="max-height: 50.5vh; overflow: auto">
            Web browser:<br />
            URL: https://comptia.org/profiles/userdetails?userid=103<br /><br /><br />
            Web server code:<br />
            ----<br />
            String accountQuery = "SELECT * from users WHERE userid = ?"<br />
            PreparedStatement stmt = connection.prepareStatement(accountQuery);<br />
            stmt.setString(1, request.getParamater("userid"));<br />
            ResultSet queryResponse = stmt.executeQuery()<br />
            ----<br />
            <br />
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-6/12 md:w-6/12 sm:w-5/5">
        <vx-card class="mb-base">
          <h3 class="font-bold mb-6 main-bottom-border pb-4">Code Snippet #2</h3>

          <div class="mb-6 w-full">
            <h4>Vulnerability</h4>
            <v-select
              placeholder="Select the vulnerability from the dropdown"
              class="w-full mt-2"
              :options="[
                'SQL Injection',
                'Cross-site request forgery',
                'Server-side request forgery',
                'Indirect object reference',
                'Cross-site scripting',
              ]"
              v-model="snippets[1].vulnerabilityValue"
            />

            <small v-if="snippets[1].vulnerabilityMarked === true" class="ml-1 text-success font-semibold">This answer is correct</small>
            <small v-if="snippets[1].vulnerabilityMarked === false" class="ml-1 text-danger font-semibold">This answer is incorrect</small>
          </div>

          <div class="mb-6 w-full">
            <h4>Fix</h4>
            <v-select
              placeholder="Select the fix from the dropdown"
              class="w-full mt-2"
              :options="[
                'Perform input sanitization of the userid field.',
                'Perform output encoding of queryResponse',
                'Ensure usex:ia belongs to logged-in user',
                'Inspect URLS and disallow arbitrary requests.',
                'Implement anti-forgery tokens.',
              ]"
              v-model="snippets[1].fixValue"
            />

            <small v-if="snippets[1].fixMarked === true" class="ml-1 text-success font-semibold">This answer is correct</small>
            <small v-if="snippets[1].fixMarked === false" class="ml-1 text-danger font-semibold">This answer is incorrect</small>
          </div>

          <div class="text-success bg-light main-border p-4 rounded" style="max-height: 50.5vh; overflow: auto">
            Caller:<br />
            URL: https://comptia.org/api/userprofile?userid=103<br /><br /><br />
            API endpoint (/searchDirectory):<br />
            ----<br />
            import subprocess<br />
            from http.server import HTTPServer, BaseHTTPRequestHandler<br />
            httpd = HTTPServer((192.168.0.5, 8443), BaseHTTPRequestHandler)<br />
            httpd.serve_forever()<br />
            <br />
            def get_request(request):<br />
            &nbsp;&nbsp;&nbsp;userId = request.getParam(userid)<br />
            <br />
            &nbsp;&nbsp;&nbsp; ldapLookup = 'ldapsearch -D "cn' + 'userId + '" -W -p 389<br />
            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-h loginserver.comptia.org<br />
            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-b "dc=comptia,dc=org" -s sub -x "(objectclass=*)"'<br />
            <br />
            &nbsp;&nbsp;&nbsp;accountLookup = subprocess.popen(ldapLookup)<br />
            <br />
            &nbsp;&nbsp;&nbsp;if (userExists(accountLookup))<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;accountFound = true<br />
            &nbsp;&nbsp;&nbsp;else<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;accountFound = false<br />
            ----<br />
            <br />
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },

      snippets: [
        {
          vulnerabilityAnswer: 'SQL Injection',
          vulnerabilityValue: null,
          vulnerabilityMarked: null,
          fixAnswer: 'Perform input sanitization of the userid field.',
          fixValue: null,
          fixMarked: null,
        },
        {
          vulnerabilityAnswer: 'Cross-site request forgery',
          vulnerabilityValue: null,
          vulnerabilityMarked: null,
          fixAnswer: 'Implement anti-forgery tokens.',
          fixValue: null,
          fixMarked: null,
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.snippets.forEach((snippet, index) => {
        console.log(snippet);

        if (snippet.vulnerabilityValue === snippet.vulnerabilityAnswer) {
          this.snippets[index].vulnerabilityMarked = true;
          totalScore++;
        } else {
          this.snippets[index].vulnerabilityMarked = false;
        }

        if (snippet.fixValue === snippet.fixAnswer) {
          this.snippets[index].fixMarked = true;
          totalScore++;
        } else {
          this.snippets[index].fixMarked = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
